export default __webpack_public_path__ + "static/media/txrDesktop.ce979c34.png";